// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.token-progress {
  margin-top: 1.25rem;
  padding: 20px;
  border-radius: 20px;
  background-color: rgba(43, 7, 77, 0.85);
  box-shadow: 0 0 14px 0 #ff2481;
  min-height: 360px;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center; }
  .token-progress__wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: -moz-fit-content;
    height: fit-content; }
  .token-progress__header {
    width: 100%;
    text-align: center;
    margin-bottom: 1rem;
    position: relative; }
  .token-progress__title {
    font-family: "Outfit", sans-serif;
    font-size: 24px;
    font-weight: 600;
    color: #ffffff; }
  .token-progress__subtitle {
    font-family: "Outfit", sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #ffffff; }
    .token-progress__subtitle span {
      font-family: "Outfit", sans-serif;
      font-size: 16px;
      font-weight: 600;
      color: #ffffff; }
  .token-progress__barWrapper {
    display: flex;
    position: relative;
    flex-direction: column-reverse;
    width: 80%;
    border-radius: 5px;
    height: 60px; }
    .token-progress__barWrapper .progress-bar {
      background-color: #ff2481;
      border-radius: 5px;
      transition: width 0.5s ease;
      min-width: 40px !important; }
      .token-progress__barWrapper .progress-bar::before {
        content: attr(data-percent);
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 12px;
        font-weight: 600;
        color: #fff; }
  .token-progress__meteor {
    position: absolute;
    bottom: 20px;
    right: -40px; }
  .token-progress__info {
    position: absolute;
    top: 9px; }
  .token-progress__countdown {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-top: 1rem;
    margin-bottom: 1rem;
    width: 80%; }
  .token-progress__countdown-time {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 1.3rem; }
  .token-progress__countdown-time-value {
    border-radius: 4px;
    padding: 10px;
    background-color: #ff2481;
    color: #ffffff; }
  .token-progress__countdown-time-text {
    margin-left: 5px;
    font-weight: 500; }
  .token-progress.show {
    transform: translateX(0); }
  .token-progress.hide {
    transform: translateX(100%); }

.token-progess-amount {
  color: #ff2481;
  width: 20px; }

.token-progess-amountDevider {
  margin-left: 5px;
  margin-right: 5px;
  width: 20px; }

.token-progess-totalToken {
  color: #ffffff; }

@media (max-width: 997px) {
  .token-progress {
    margin-top: 1.25rem;
    padding: 20px;
    border-radius: 20px;
    background-color: rgba(43, 7, 77, 0.85);
    box-shadow: 0 0 14px 0 #ff2481;
    min-height: 488px; }
    .token-progress__meteor {
      right: -20px;
      bottom: 48px; } }
`, "",{"version":3,"sources":["webpack://./src/components/TokenComponents/TokenSalesProgress/style.scss","webpack://./src/styles/mixins/mixins.scss","webpack://./src/styles/variables/_variables.scss"],"names":[],"mappings":"AAGA;ECII,mBAAmB;EACnB,aAAa;EACb,mBCOuB;EDNvB,uCCT0B;EDU1B,8BCEqC;EDDrC,iBDRyB;EAC3B,cEFuB;EFGvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB,EAAA;EAEvB;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,wBAAmB;IAAnB,mBAAmB,EAAA;EAGrB;IACE,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB,EAAA;EAGpB;ICzBE,iCAAiC;IACjC,eDyB4B;ICxB5B,gBDwBiC;IACjC,cEzBqB,EAAA;EF4BvB;IC9BE,iCAAiC;IACjC,eD8B4B;IC7B5B,gBD6BiC;IACjC,cE9BqB,EAAA;IF4BtB;MC9BC,iCAAiC;MACjC,eDkC8B;MCjC9B,gBDiCmC;MACjC,cElCmB,EAAA;EFsCvB;IACE,aAAa;IACb,kBAAkB;IAClB,8BAA8B;IAC9B,UAAU;IACV,kBAAkB;IAClB,YAAY,EAAA;IANb;MASG,yBE7B8B;MF8B9B,kBAAkB;MAClB,2BAA2B;MAC3B,0BAA0B,EAAA;MAZ7B;QAeK,2BAA2B;QAC3B,kBAAkB;QAClB,QAAQ;QACR,SAAS;QACT,gCAAgC;QAChC,eAAe;QACf,gBAAgB;QAChB,WAAW,EAAA;EAIjB;IACE,kBAAkB;IAClB,YAAY;IACZ,YAAY,EAAA;EAEd;IACE,kBAAkB;IAClB,QAAQ,EAAA;EAGV;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,gBAAgB;IAChB,mBAAmB;IACnB,UAAU,EAAA;EAGZ;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB,EAAA;EAGnB;IACE,kBAAkB;IAClB,aAAa;IACb,yBE3EgC;IF4EhC,cE9FqB,EAAA;EFiGvB;IACE,gBAAgB;IAChB,gBAAgB,EAAA;EAnGpB;IAsGI,wBAAwB,EAAA;EAtG5B;IA0GI,2BAA2B,EAAA;;AAI/B;EACE,cE7FkC;EF8FlC,WAAW,EAAA;;AAEb;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW,EAAA;;AAGb;EACE,cEzHuB,EAAA;;AF4HzB;EACE;ICzHE,mBAAmB;IACnB,aAAa;IACb,mBCOuB;IDNvB,uCCT0B;IDU1B,8BCEqC;IDDrC,iBDqH2B,EAAA;IAC3B;MACE,YAAY;MACZ,YAAY,EAAA,EACb","sourcesContent":["@import \"../../../styles/variables/variables\";\n@import \"../../../styles/mixins/mixins.scss\";\n\n.token-progress {\n  @include tokenSection(360px);\n  color: $tokenWhiteColor;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n\n  &__wrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    height: fit-content;\n  }\n\n  &__header {\n    width: 100%;\n    text-align: center;\n    margin-bottom: 1rem;\n    position: relative;\n  }\n\n  &__title {\n    @include tokenFontMixin(24px, 600);\n    color: $tokenWhiteColor;\n  }\n\n  &__subtitle {\n    @include tokenFontMixin(16px, 400);\n    color: $tokenWhiteColor;\n\n    & span {\n      @include tokenFontMixin(16px, 600);\n      color: $tokenWhiteColor;\n    }\n  }\n\n  &__barWrapper {\n    display: flex;\n    position: relative;\n    flex-direction: column-reverse;\n    width: 80%;\n    border-radius: 5px;\n    height: 60px;\n\n    .progress-bar {\n      background-color: $tokenButtonBackgroundColor;\n      border-radius: 5px;\n      transition: width 0.5s ease;\n      min-width: 40px !important;\n\n      &::before {\n        content: attr(data-percent);\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        font-size: 12px;\n        font-weight: 600;\n        color: #fff;\n      }\n    }\n  }\n  &__meteor {\n    position: absolute;\n    bottom: 20px;\n    right: -40px;\n  }\n  &__info {\n    position: absolute;\n    top: 9px;\n  }\n\n  &__countdown {\n    display: flex;\n    justify-content: center;\n    gap: 20px;\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n    width: 80%;\n  }\n\n  &__countdown-time {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 1.3rem;\n  }\n\n  &__countdown-time-value {\n    border-radius: 4px;\n    padding: 10px;\n    background-color: $tokenButtonBackgroundColor;\n    color: $tokenWhiteColor;\n  }\n\n  &__countdown-time-text {\n    margin-left: 5px;\n    font-weight: 500;\n  }\n  &.show {\n    transform: translateX(0);\n  }\n\n  &.hide {\n    transform: translateX(100%);\n  }\n}\n\n.token-progess-amount {\n  color: $tokenButtonBackgroundColor;\n  width: 20px;\n}\n.token-progess-amountDevider {\n  margin-left: 5px;\n  margin-right: 5px;\n  width: 20px;\n}\n\n.token-progess-totalToken {\n  color: $tokenWhiteColor;\n}\n\n@media (max-width: 997px) {\n  .token-progress {\n    @include tokenSection(488px);\n    &__meteor {\n      right: -20px;\n      bottom: 48px;\n    }\n  }\n}\n","@mixin tokenFontMixin($fontSize, $fontWeight) {\n    font-family: \"Outfit\", sans-serif;\n    font-size: $fontSize;\n    font-weight: $fontWeight;\n}\n\n@mixin tokenSection($height) {\n    margin-top: 1.25rem;\n    padding: 20px;\n    border-radius: $tokenContainerRadius;\n    background-color: $tokenContainerBackgroundColor;\n    box-shadow: $tokenContainerShadow;\n    min-height: $height;\n}\n\n@mixin tokenMainButton($color, $backgroundColor) {\n    background-color: $backgroundColor;\n    color: $color;\n    padding: 0.5em 1em;\n    border: 1.85px solid $tokenButtonBorderColor;\n    cursor: pointer;\n    border-radius: 6px;\n\n    &:hover {\n        background-color: $tokenButtonHoverColor;\n    }\n}\n\n@mixin tokenOutlineButton($color, $backgroundColor) {\n    background-color: $backgroundColor;\n    color: $color;\n    padding: 0.5em 1em;\n    border: 2px solid $tokenButtonBackgroundColor;\n    cursor: pointer;\n    border-radius: 6px;\n\n    &:hover {\n        background-color: $tokenButtonHoverColor;\n    }\n}\n","// Main Colors\n$tokenBackgroundColor: #2b074d;\n$tokenContainerBackgroundColor: rgba($tokenBackgroundColor, 0.85);\n$tokenWhiteColor: #ffffff;\n$tokenBlackColor: #000000;\n$tokenPlaceholderColor: #757179;\n\n// Status Colors\n$tokenVerifyStatus: #60ffa8;\n$tokenPendingStatus: #ffdb81;\n$tokenErrorStatus: #ff0000;\n\n// SHADOW\n$tokenContainerShadow: 0 0 14px 0 #ff2481;\n\n// BORDER\n$tokenContainerRadius: 20px;\n$tokenContainerBorderColor: #340c5a;\n\n// BUTTON\n$tokenButtonBorderColor: #e02574;\n$tokenButtonBackgroundColor: #ff2481;\n$tokenButtonHoverColor: #e02574;\n\n// COIN BACKGROUND\n$tokenCoinBackground: #ededed;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
